import React, {Component} from 'react'
import SignupForm from '../../components/SignupForm'

export default class signupnow extends Component {
  render() {
    return (
      <div className="py-16 th-home--mobilebottom2 " style={{marginTop: '4rem', marginBottom: '4rem'}}>
        <div className="container grid-xl ">
          <div className="text-center">
            <div className="h1 th-font-av th-home--mobilefonth1 " style={{color: '#000000'}}>
              Get serious offers faster.
            </div>
            <div className="h4 th-home--mobilefonth4" style={{marginTop: '1.2rem', color: '#00414b', marginBottom: '2rem'}}>
              The trusted listing tool kit for over 100,000 on-the-go real estate professionals
            </div>
          </div>
        </div>
        <div class="container grid-sm">
          <SignupForm size="md" />
        </div>
      </div>
    )
  }
}
